<template>
    <div id="app">
        <router-view/>
        <rolivechatservice></rolivechatservice>
    </div>
</template>

<script>
import rolivechatservice from "./views/components/ro_livechat_service.vue";

export default {
    components: {
        rolivechatservice
    }
}
</script>

<style lang="scss">
html,
body {
    width: 100%;
    height: 100%;
    margin: 0 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
